<!-- Button -->
<button
    mat-icon-button
    class="ml-2"
    aria-label="User menu"
    matTooltip="User menu"
    [matMenuTriggerFor]="userActions"
>
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img
                class="user-avatar-button h-7 w-7 rounded-full object-cover object-center"
                [src]="user.avatar"
                alt="User avatar"
            />
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        @if (user.status) {
            <span
                class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
                [ngClass]="{
                    'mb-px mr-px': !showAvatar || !user.avatar,
                    'bg-green-500': user.status === 'online',
                    'bg-amber-500': user.status === 'away',
                    'bg-red-500': user.status === 'busy',
                    'bg-gray-400': user.status === 'not-visible',
                }"
            ></span>
        }
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu"
    class="user-menu"
>
    <!-- Signed in header -->
    <div class="flex items-center gap-3 px-4 py-3">
        @if (user.avatar) {
            <span class="user-avatar-menu-frame">
                <img
                    class="user-avatar-menu h-10 w-10 rounded-full object-cover object-center"
                    [src]="user.avatar"
                    alt="User avatar"
                />
                <span class="user-avatar-menu-status" aria-hidden="true"></span>
            </span>
        }
        @if (!user.avatar) {
            <span class="user-avatar-menu-frame user-avatar-menu-frame--empty">
                <mat-icon
                    class="icon-size-10 text-hint"
                    [svgIcon]="'heroicons_outline:user-circle'"
                ></mat-icon>
                <span class="user-avatar-menu-status" aria-hidden="true"></span>
            </span>
        }
        <div class="flex min-w-0 flex-col leading-tight">
            <span class="text-secondary text-xs">Signed in as</span>
            <span class="truncate font-medium">{{ user.name }}</span>
            <span class="truncate text-xs font-medium user-menu-role">
                {{ user.position }}
            </span>
        </div>
    </div>

    <mat-divider class="my-1"></mat-divider>

    <button mat-menu-item (click)="goPortal()">
        <mat-icon [svgIcon]="'heroicons_outline:home'"></mat-icon>
        <span>Main Menu</span>
    </button>

    <mat-divider class="my-1"></mat-divider>

    <button mat-menu-item class="user-menu-signout" (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
